'use client';

import { useCallback, useEffect, useState } from 'react';
import Link from 'next/link';
import styles from './CookieConsent.module.css';

const STORAGE_KEY = 'zvir_cookie_consent_v1';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (typeof window === 'undefined') return;
      const stored = window.localStorage.getItem(STORAGE_KEY);
      if (stored !== 'accepted') {
        setVisible(true);
      }
    } catch {
      setVisible(true);
    }
  }, []);

  const accept = useCallback(() => {
    try {
      window.localStorage.setItem(STORAGE_KEY, 'accepted');
    } catch {
      /* ignore */
    }
    setVisible(false);
  }, []);

  if (!visible) return null;

  return (
    <div className={styles.bar} role="dialog" aria-label="Уведомление о cookie">
      <p className={styles.text}>
        Мы используем cookie и аналитику для улучшения работы сайта. Подробнее — в{' '}
        <Link href="/cookies" className={styles.link}>
          политике использования cookie
        </Link>
        .
      </p>
      <button type="button" className={styles.button} onClick={accept}>
        Принять
      </button>
    </div>
  );
}
